'use client'

import { useEffect, useRef } from 'react'
import { useRouter } from 'next/navigation'

/**
 * Listens for 'atrium-data-changed' events (dispatched by ChatInterface
 * after mutating tool calls) and refreshes the current page's server data.
 *
 * Place this in any page layout that should live-update when the chat
 * modifies data.
 */
export function DataRefreshListener() {
  const router = useRouter()
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const handler = () => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
      debounceTimerRef.current = setTimeout(() => {
        debounceTimerRef.current = null
        // Coalesce bursts (multiple mutating tools in one turn) so we don't spam router.refresh → GET /current-route
        router.refresh()
      }, 500)
    }

    window.addEventListener('atrium-data-changed', handler)
    return () => {
      window.removeEventListener('atrium-data-changed', handler)
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
    }
  }, [router])

  return null
}
